export default {
    userLogin: '/user/login', // 用户登录 POST
    getCode: '/user/get_code', // 获取验证码 POST
    userLogout: '/user/logout', // 退出登录
    // index
    indexOrderCount: '/index/get_orders', // 首页订单数量提示
    getArticles: '/index/get_articles', // 获取推荐文章
    getCarShort: '/index/car_sort', // 车牌 省
    getCarLetter: '/index/car_letter', // 车牌 区/市
    getBrandList: '/index/get_brand_list', // 车辆品牌
    getLineList: '/index/get_line_list', // 车系
    getModelList: '/index/get_car_list', // 车型
    // sstoreCardOrder
    carNumUsed: '/SstoreCardOrder/get_pc_used_car_num', // 最近创建车牌
    checkCarNum: '/SstoreCardOrder/check_car_num', // 检查车牌
    storeCardList: '/SstoreCardOrder/get_sstore_card_list',
    createCardOrder: '/SstoreCardOrder/create_sstore_card_order', // 生成爱车卡订单 POST
    latestCustomerInfo: '/SstoreCardOrder/get_last_user_info_by_car_no', // 读取车牌最新的用户信息
    // pcOrder
    hangoutOrder: '/PcOrder/get_not_pay_order', // 根据车牌获取挂账订单
    createOrder: '/PcOrder/create_order', // 生成普通订单 POST
    orderList: '/PcPickcarOrder/lists', // 订单列表
    // PcOrder110
    maintenanceList: '/PcOrder/get_goods_list', // 保养查询 v1.1
    // pcordergoods
    getStoreService: '/PcOrderGoods/get_sstore_servers', // 获取门店服务列表
    getStoreGoodsList: '/PcOrderGoods/get_goods_list', // 获取门店商品列表
    getGoodsCate: '/PcOrderGoods/get_cate_list', // 获取商品分类
    getWorkerList: '/PcOrderGoods/get_sstore_worker_list', // 获取师傅列表
    // gainrecord
    getGainDetail: '/GainRecord/get_order_detail', // 收益详情
    getGainList: '/GainRecord/get_order_lists_by_service_type', // 收益列表
    exportGain: '/GainRecord/export_order_list', // 导出收益记录
    // stat
    income: '/stat/income_stat', // 门店收益统计
    pcIncome: '/stat/payment_stat', // pc收益统计
    orderRecent: '/stat/order_stat', // 最近订单统计

    // v1.2储值卡, 车主车辆管理, 车主营销
    pcChargeCardList: '/PcOrder/get_sstore_recharge_card_package_list', // 门店储值卡套餐列表
    createChargeOrder: '/PcOrder/create_recharge_card_order', // 生成储值卡订单
    correctChargeOrder: '/PcOrder/correct_pc_recharge_order', // 更正订单
    correctChargeRecord: '/PcOrder/get_recharge_correct_record', // 储值卡更正记录
    chargeOrderList: '/PcOrder/get_pc_recharge_list', // 储值卡订单列表
    getRechargeRight: '/PcOrder/check_is_recharge', // 获取门店是否开通储值卡
    // 用户, 车辆
    carList: '/CustomerManage/cars_list', // 车辆列表
    carDetail: '/CustomerManage/car_detail', // 车辆详情
    carEdit: '/CustomerManage/edit_sstore_car', // 编辑车辆
    userList: '/CustomerManage/get_user_list', // 用户列表
    userInfo: '/CustomerManage/get_user_info', // 用户详情
    // 车主营销
    storeMessageConfig: '/CustomerManage/sstore_message_config', // 门店剩余短信及设置
    sendPromotMsg: '/CustomerManage/send_message', // 营销短信发送

    // v1.3权限管理, 员工管理, 日志, 系统通知
    authList: '/AccessControl/get_auth_list', // 权限列表, 用于编辑
    authTpl: '/AccessControl/get_role_template_list', // 系统推荐配置权限
    roleList: '/AccessControl/get_role_list', // 角色列表
    roleDetail: '/AccessControl/get_role_info', // 角色详情
    roleEdit: '/AccessControl/update_admin_role', // 角色编辑/添加
    deleteRole: '/AccessControl/del_admin_role', // 删除角色

    // 管理员
    staffList: '/AccessControl/get_admin_list', // 管理员列表
    staffDetail: '/AccessControl/get_admin_info', // 管理员详情
    staffEdit: '/AccessControl/update_admin_user', // 管理员编辑
    staffAdd: '/AccessControl/add_admin_user', // 添加管理员
    deleteStaff: '/AccessControl/del_admin_user', // 删除管理员
    exportStaff: '/AccessControl/export_admin_list', // 导出管理员列表
    // 员工
    workersList: '/AccessControl/get_worker_list', // 员工列表, (师傅列表没参数不动)
    workersAction: '/AccessControl/sstore_worker_action', // 员工操作
    exportWorkers: '/AccessControl/export_worker_list', // 导出员工列表
    // 系统通知
    noticeList: '/notice/get_notice_list', // 通知列表
    noticeDetail: '/notice/get_notice_info', // 通知详情
    // 日志
    logList: '/AccessControl/get_pc_operation_log_list', // 日志列表
    exportLogList: '/AccessControl/export_pc_operation_log_list', // 导出日志
    // 登录管理员 权限详情
    userAuth: '/index/get_admin_info', // 130新接口

    // v1.4预测营销
    predictList: '/CustomerManage/sstore_marketing_forecast', // 预测营销列表
    predictMsg: '/CustomerManage/get_message_content_info', // 发送短信内容
    sendPredictMsg: '/CustomerManage/send_predicted_message', // 发送预测短信
    predictImgCode: '/CustomerManage/get_sstore_goods_detail_qrcode', // 商品二维码
    getAgentGoodsDetail: '/CustomerManage/get_goods_detail', // 需要代理商品详情
    setAgentGoods: '/CustomerManage/set_agent', // 代理商品
    cardBalance: '/PcOrder/get_recharge_card_balance', // 140 获取用户储值卡余额
    predictedMarketing: '/CustomerManage/get_predicted_marketing_notice', // 获取营销预测提示
    // v1.45 储值卡赠送服务修改
    prePaidOrderDetail: '/PcOrder/get_recharge_card_order_detail', // 储值卡订单详情
    // v1.5 核销爱车卡
    userCardList: '/SstoreCardOrder/sstore_card_search_list', // 获取用户爱车卡列表
    // v1.55 广告
    menuAdvertising: '/advertising/get_advertising', // 获取菜单广告
    // v.16
    getCompanyName: '/PcOrderGoods/get_sstore_company', // 获取公司名列表
    finishOrderIds: '/PcOrder/finish_order_by_ids', //  根据订单id批量完成挂账订单
    finishOrderCondition: '/PcOrder/finish_order_by_condition', // 根据搜索条件批量完成挂账订单
    getLogCompanyList: '/AccessControl/get_pc_company_list', // 获取批量完成列表
    getDefaultCate: '/PcOrderGoods/get_default_cate', // 推荐门店临时商品分类
    getTempGoodsList: '/PcOrderGoods/get_temp_goods_list', // 门店临时商品列表
    addTempGoods: '/PcOrderGoods/add_temp_goods', // 门店添加临时商品
    // v1.7
    historyList: '/PcOrder/get_import_record_list', // 历史导入数据列表
    exportHistory: '/PcOrder/export_import_record_list', // 导出历史记录
    // v1.75
    operatingInstructions: '/article/operate_desc', // 获取操作说明信息
    checkOperateStatus: '/article/check_operate_status', // 获取操作说明状态 显示or隐藏
    // v1.8
    worderExportOrderList: '/PickcarOrder/export_list', // 导出接车师傅订单列表
    worderList: '/PickcarOrder/lists', // 查看施工单列表
    worderOrderFinish: '/PickcarOrder/order_pay',  // 接车师傅订单状态设置为完成
    worderOrderCancel: '/PickcarOrder/order_cancel', // 接车师傅订单状态设置为取消
    // worderOrderInfo: '/PickcarOrder/get_order_info', // 接车师傅订单详情
    paymentStatByPickcar: '/stat350/payment_stat_by_pickcar', // 收益统计-施工单收入统计
    // v1.9
    inboundRecord: '/InventoryCharge/inbound_record', // 入库管理列表
    getCateList: '/GoodsManage/get_cate_list', // 获取所有商品分类
    getSelfGoodsList: '/GoodsManage/get_self_goods_list', // 获取自营商品列表
    getGoodsTmpList: '/GoodsManage/get_goods_template_by_cate_id', // 根据商品分类获取商品模板列表
    supplierList: '/InventoryCharge/supplier_list', // 供应商列表
    getCustomizeExample: '/GoodsManage/get_customize_example', // 获取自定义商品导入模板
    deleteSelfGoods: '/GoodsManage/delete_goods', // 删除自营商品
    selfGoodsBatchUpDown: '/GoodsManage/edit_is_show', // 自营商品批量上架下架
    inbound: '/InventoryCharge/inbound', // 入库操作
    outbound: '/InventoryCharge/outbound', // 出库操作
    outboundRecord: '/InventoryCharge/outbound_record', // 出库列表
    agentList: '/CloudShelf/agent_list', // 已代理商品列表
    getStoreCouponGoodsList: '/CloudShelf/get_store_coupon_goods_list', // 未代理商品列表（匹配、活动、全部）
    agentEdit: '/CloudShelf/agent_edit', // 设置/编辑代理商品
    agentAdd: '/CloudShelf/agent_add', // 添加代理商品
    getCanAgentGoods: '/CloudShelf/get_can_agent_goods', // 门店可代理的商品数量
    agentCancle: '/CloudShelf/agent_cancle', // 移除代理商品-批量
    agentDel: 'CloudShelf/agent_del', // 移除代理商品-一键
    saleRegionGoods: '/CloudShelf/sale_region_goods', // 判断商品是否在销售区域
    getWxcodeUrl: '/CloudShelf/get_wxcode_url', // 获取门店商品分享二维码
    getGoodsBrandList: '/GoodsManage/get_brand_list', // 获取商品品牌
    getGoodNameList: '/GoodsManage/get_spu_goods_name', // 获取商品名称
    getTemplateInfo: '/GoodsManage/get_template_info', // 根据模板id获取模板详情
    upLoadFile: '/GoodsManage/upload_file', // 上传文件
    getCateName: '/GoodsManage/get_cate_name', // 根据分类id获取分类名称
    getGoodsParam: '/GoodsManage/get_goods_attr_by_cate_id', // 获取自营商品编辑 参数值
    getSelfGoodsInfo: '/GoodsManage/get_self_goods_info', // 根据商品规格id获取商品详情
    checkGoodsStock: '/PcOrder/check_goods_stock', // 收银开单-检测商品库存状态
    editSelfGoods: '/GoodsManage/edit_self_goods', // 编辑自营商品、自定义商品
    saveSelfGoods: '/GoodsManage/save_self_goods', // 添加/编辑自营商品、自定义商品
    importCustomizeDataPOST: '/GoodsManage/import_customize_data', // 导入自定义商品
    inboundRecordDetail: '/InventoryCharge/inbound_record_detail', // 入库详情
    outboundRecordDetail: '/InventoryCharge/outbound_record_detail', // 出库详情
    getLogGoods: '/AccessControl/get_log_goods', // 操作日记 - 查看
    // v2.0
    getAlipayAccount: '/PcOrder/get_sstore_alipay_account', // 检查门店是否设置支付宝账号
    checkOrderStatus: '/PcOrder/check_order_status', // 检查挂账订单状态
    checkPickcarOrder: '/PickcarOrder/check_pickcar_order', // 检查接车未支付订单状态
    // 1.95 (师傅4.2)
    selectWorker: '/PickcarOrder/select_worker', // 选择师傅
    // 2.01 (枫车门店APP6.95)
    checkCardLimit: '/SstoreCardOrder/check_card_limit', // 查询爱车卡是否超过限购数量
    // 2.1 (数据统计)
    businessData: '/stat/business_data', // 首页-营业统计
    allTypeOrderNum: '/stat/all_type_order_num', // 数据概览-类型订单数量统计
    incomeTrend: '/stat/income_trend', // 数据概览-收入金额趋势
    orderNumTrend: '/stat/order_num_trend', // 数据概览-订单数趋势
    payUsersNumTrend: '/stat/pay_users_num_trend', // 数据概览-支付用户数趋势
    goodsSurvey: '/stat/goods_survey', // 商品分析-商品概览
    goodsSalesTrend: '/stat/goods_sales_trend', // 商品分析-商品销量趋势
    goodsSalesChannelAnalysis: '/stat/goods_sales_channel_analysis', // 商品分析-销售渠道趋势
    goodsSalesRanking: '/stat/goods_sales_ranking', // 商品分析-商品销量排行
    sstoreCardOverview: '/stat/sstore_card_overview', // 爱车卡总览
    sstoreCardSalesTrend: '/stat/sstore_card_sales_trend', // 爱车卡销量趋势
    sstoreCardWriteOffChannel: '/stat/sstore_card_write_off_channel', // 爱车卡核销渠道分析
    sstoreCardSalesRanking: '/stat/sstore_card_sales_ranking', // 爱车卡销量排行榜
    servicePackageOverview: '/stat/service_package_overview', // 营销活动总览
    servicePackageSalesTrend: '/stat/service_package_sales_trend', // 营销活动销量趋势
    servicePackageWriteOffChannel: '/stat/service_package_write_off_channel', // 营销活动核销渠道分析
    servicePackageSalesRanking: '/stat/service_package_sales_ranking', // 营销活动销量排行榜
    serviceAppointmentOverview: '/stat/service_appointment_overview', // 服务预约总览
    serviceAppointmentSalesTrend: '/stat/service_appointment_sales_trend', // 服务预约趋势
    serviceAppointmentSalesRanking: '/stat/service_appointment_sales_ranking', // 服务预约排行榜
    consumptionRateSurvey: '/stat/consumption_rate_survey', // 消费频次分析
    consumptionTimeSurvey: '/stat/consumption_time_survey', // 最近消费时间分析
    valuecardOverview: '/stat/valuecard_overview', // 储值卡概况
    valuecardSalesTrend: '/stat/valuecard_sales_trend', // 储值卡销量趋势
    valuecardUsedChannelAnalysis: '/stat/valuecard_used_channel_analysis', // 储值卡核销渠道分析
    customerOverview: '/stat/customer_overview', // 客户分析-客户总览
    consumptionAnalysis: '/stat/consumption_analysis', // 客户分析-消费金额分析
    // 2.2 (车检管理)
    isCreatedTemplate:'/CustomerManage/check_sstore_is_create_template', // 运营后台有没有设置车检模板
    getTemplate: '/CustomerManage/vehicle_inspection_template_list', // 展示自定义车检模板，用户没有创建模板为空，用户创建模板初始化为标准模板供用户自定义
    getSystem: '/CustomerManage/vehicle_inspection_system_list', // 获取车检系统类目
    saveProject: '/CustomerManage/save_vehicle_inspection_project_template', // 新增和编辑车检项目
    removeProject: '/CustomerManage/del_vehicle_inspection_project', // 删除车检项目
    restoreTemplate: '/CustomerManage/initialize_vehicle_inspection_template', // 恢复标准模板
    createTemplate: '/CustomerManage/create_sstore_vehicle_inspection_template', // 创建车检模板
    getCarsExam:'/CustomerManage/get_car_report_list', // 获取车检报告
    getExamdetail:'/CustomerManage/get_car_report_info', // 获取车检详情
    getNewExam:'/CustomerManage/get_car_info_before_report',  // 新增车检报告获取车辆相关信息
    newExamCommit:'/CustomerManage/add_car_report', // 新增车检 提交车检报告
    examEditCommit:'/CustomerManage/edit_car_report', // 编辑车检报告 提交
    lockExam:'/CustomerManage/edit_lock', // 编辑车检 锁
    unlockExam:'/CustomerManage/edit_unlock', // 编辑车检 解锁
    getArrivalRecords:'/stat/get_arrival_records', // 到店历史记录列表历史纪录
    getNotPayRecords:  '/stat/get_not_pay_orders', // 到店未支付订单列表历史纪录
    getCarHistoryDetails: '/stat/get_history_order_info', // 到店订单/核销详情
    delExam:'/CustomerManage/del_report', // 删除车检报告
    // 2.4 (服务优化)
    getServiceCategoryOne: '/SstoreService/get_service_category_list', // 获取门店服务服务一级分类
    getServiceCategoryTwo: '/SstoreService/get_service_category_second_list', // 根据一级服务分类获取二级服务分类
    getServiceTagOne: '/SstoreService/get_tag_category_list', // 获取一级活动标签分类
    getServiceTagTwo: '/SstoreService/get_tag_category_sencond_list', // 根据一级服务分类获取二级标签分类
    getServiceTemList: '/SstoreService/get_sstore_license_list', // 获取服务模板列表
    getServiceList: '/SstoreService/get_service_list', // 获取服务列表
    hasMiniPro: '/SstoreService/get_mini_sstore_status', // 判断用户是否开通小程序
    getServicePreview: '/SstoreService/get_service_detail_code_img', // 获取小程序服务预览码
    getTemWithKeyword: '/SstoreService/get_not_used_template', // 输入关键字获取未调用模板
    getPreTemDetail: '/SstoreService/service_tempel_info', // 添加标准服务获取模板预设信息
    getActivityList: '/SstoreService/get_service_cate', // 获取活动标签列表
    getServiceTemNumber: '/SstoreService/get_not_used_template_count', // 获取未调用模板数量
    removeService: '/SstoreService/del_service', // 删除指定服务
    isShowNoUseTemTip: '/SstoreService/get_is_show_prompt', // 用户选择自定义服务时是否显示确认不使用模板提示对话框
    hideNoUseTemTip: '/SstoreService/set_is_show_prompt', // 用户点击不再显示提示框
    getRelativeServiceList: '/SstoreService/get_service_rel_list', // 获取关联服务列表
    fastOnService: '/SstoreService/edit_rel_service', // 快速上架服务
    offServiceHint: '/SstoreService/get_fail_reson', // 服务下架提醒
    handleService: '/SstoreService/show_sstore_goods', // 服务上架
    saveService: '/SstoreService/add_sstore_goods', // 添加服务保存
    editService: '/SstoreService/edit_sstore_goods', // 编辑服务保存
    getServiceEditInfo: 'SstoreService/get_goods_info', // 编辑服务获取服务详情
    getAllCard:'/PcOrder/get_user_service_list', // 获取用户所有核销卡
    handleServiceOff: '/SstoreService/unshow_sstore_goods', // 服务下架
    getServiceDate: '/stat/get_local_time', // 获取服务器时间
    // 2.6 (保养营销-核销记录)
    getOwnerActivity: '/CustomerManage/service_package_list', // 获取车主营销活动列表
    getOwnerSstoreCard: '/CustomerManage/sstore_card_list', // 获取车主爱车卡列表
    modifySstoreCardDeadline: '/CustomerManage/sstore_card_update_expire_time', // 修改爱车卡有效期
    getOwnerRechargeCard: '/CustomerManage/recharge_card_list', // 获取车主储值卡列表
    getBusinessRecord: '/CustomerManage/business_records', // 获取车主业务记录列表
    getSstoreCardUseRecord: '/GainRecord/sstore_card_use_records', // 获取核销记录列表
    getSstoreCardUseDetail: '/GainRecord/sstore_card_use_detail', // 获取核销记录详情
    revokeUserService: '/GainRecord/revoke_user_service', // 撤销核销记录
    getMaintainPlan: '/MaintainPlan/get_user_maintain_plan', // 获取保养方案
    getMaintainGoodsList: '/MaintainPlan/get_maintain_goods_list', // 获取门店的商品列表
    getServiceCateList: '/MaintainPlan/get_service_cate_list', // 获取门店的服务分类
    getStoreServiceList: '/MaintainPlan/get_sstore_service_list', // 获取门店的服务列表
    getStoreInfo: '/MaintainPlan/get_sstore_info', // 获取门店的信息
    getCarsList: '/MaintainPlan/cars_list', // 获取车主的车型列表
    getMaintainUserList: '/MaintainPlan/get_maintain_plan_user_list', // 车主列表
    sendMessage: '/MaintainPlan/send_message', // 保养短信营销
    sendMessageBatch: '/MaintainPlan/send_message_batch', // 批量保养短信营销
    maintainPlanSendMessage: '/MaintainPlan/maintain_plan_send_message', // 门店定制保养方案短信推送
    getRecordList: '/MaintainPlan/get_record_list', // 保养营销记录
    getRecordDetail: '/MaintainPlan/get_record_detail', // 保养营销记录详情
    maintainUserList: '/index/maintain_user_list', // 首页-今日营销
    // 2.9 在线客服
    getStoreMessage: '/index/get_unread_msg', // 门店是否有未读的会话聊天消息
    // 3.0 VIP
    getStoreVipInfo: '/sstore/get_sstore_vip_info', // 门店VIP信息
    getVipDesc: '/sstore/get_vip_desc', // 门店VIP说明

    // v3.1
    postEditCoupon: '/Coupon/add_bc_coupon', // 新建/编辑优惠券_保存or投放提交数据
    getBcCoupon: '/Coupon/get_bc_coupon', // 获取bc优惠券
    getSelectService : 'SstoreService/get_list', // 获取选中的服务列表
    getServicePackage: '/ServicePackage/get_list', // 获取上架中的营销活动搜索列表
    issueCoupon: '/Coupon/put_bc_coupon_on', // 投放优惠券
    addCouponStorage: '/Coupon/add_bc_couon_stock', // 增加bc优惠券库存
    getCouponList: '/Coupon/get_bc_coupon_list', // 获取bc优惠券列表
    getOwnerList: '/Coupon/bc_coupon_receive_user_list', // 获取优惠券车主列表
    getCouponTemList: '/Coupon/get_bc_coupon_template_list', // 获取优惠券模板列表
    removeCoupon: '/Coupon/del_bc_coupon', // 删除优惠券
    getCouponCate: '/Coupon/get_bc_coupon_template_cate', // 获取优惠券模板分类
    launchCoupon: '/Coupon/grant_bc_coupon', // 发放优惠券
    getUserAndMsgCount: '/Index/get_user_and_sms_count', // 获取门店车主数和营销信息数
    getCouponOverview: '/stat/bc_coupon_overview', // 获取优惠券概况
    getCouponTrend: '/stat/bc_coupon_trend', // 获取优惠券趋势
    getCouponRank: '/stat/bc_coupon_ranking', // 获取优惠券销量排行
    // v3.4 施工单优化+储值卡抵扣
    getGoodsShareUrl: '/CloudShelf/get_goods_share_url', // 获取代理商品推广
    getPickcarCardBalance: '/PickcarOrder/check_recharge', // 获取施工单是否可用储值卡及余额
    // v3.45 发送车检报告（枫车养车appV5.20-首页&商城改版）
    sendCarReport: '/CustomerManage/send_car_report', // 发送车检报告
    // v3.5 接车开单优化
    getPcCarInfo: '/PcPickcarOrder/get_user_info_by_car_num_and_phone', // 获取新开单的车主信息
    getGoodsOrder: '/PcPickcarOrder/get_use_goods_order_list', // 获取商品订单列表
    getPcPickcarOrder: '/PcPickcarOrder/default_goods_cate', // 获取默认商品分类
    getDefaultServiceCate:'/PcOrderGoods/get_temporary_service_default_cate', // 获取默认服务分类
    addTemporaryService: '/PcOrderGoods/add_temporary_service', // 新增临时服务
    getLateWorkOrderTotal: '/PcPickcarOrder/order_total', // 获取近30天到店工单各状态总数
    getCarInfo: '/PcPickcarOrder/get_cars_list', // 输入车牌号搜索车牌信息
    getNoPayOrder: '/PcOrder/get_not_pay_order', // 根据车牌和手机号获取未支付订单
    getLateWorkOrder: '/PcPickcarOrder/order_lists', // 获取近30天到店工单
    getCarOrderRecord: '/PcPickcarOrder/get_car_order_log', // 查询车辆历史消费记录
    getOrderSetting: '/PcPickcarOrder/get_order_setting', // 获取订单设置
    settingOrder: '/PcPickcarOrder/order_setting', // 设置订单
    orderInfo: '/PcPickcarOrder/get_order_info_by_edit', // 编辑开单详情
    addOrder: '/PcPickcarOrder/add_order', // 新增订单
    editOrder: '/PcPickcarOrder/edit_order', // 编辑订单
    completeWork: '/PcPickcarOrder/complete_order', // 完工
    uncompleteOrder: '/PcPickcarOrder/uncomplete_order', // 撤销完工
    recordOrder: '/PcPickcarOrder/record_order', // 挂账
    cancelOrder: '/PcPickcarOrder/cancel_order', // 作废
    finishOrder: '/PcPickcarOrder/finish_order', // 结算
    unFinishOrder: '/PcPickcarOrder/unfinish_order', // 反结算
    exportOrders: '/PcPickcarOrder/export_order_list', // 导出订单记录
    getUserCardRecord: '/PcPickcarOrder/user_card_list', // 用户爱车卡记录
    getCardLockList: '/PcPickcarOrder/user_card_lock_list', // 爱车卡占用说明
    copyOrderParams: '/PcPickcarOrder/copy_order_params', // 再来一单-详情
    saveAndPay: '/PcPickcarOrder/quick_finish_order', // 保存并结算
    // v3.7
    getSelfGoodsAdvert: '/Pcad/get_self_goods_onthe_right', // 自营商品列表右侧广告位
    postClickRate: '/Pcad/click_rate_increase', // 累加广告点击率
    getB2bOrderGoodsList: '/GoodsManage/b2b_order_goods_list', // 获取最近30天配件采购订单商品
    postB2bOrderGoods: '/GoodsManage/sync_b2b_order_goods', // 同步配件采购订单商品
    // v3.6 优惠券优化
    updateSort: '/Coupon/update_sort', // 修改BC优惠券的排序
    getDefaultStoreId: '/sstore/get_default_store_id', // 获取枫车商家id
    // 3.7
    getWriteoffAuthDetail: '/PcPickcarOrder/get_use_service_auth_and_hidden_num',
    getOrderCanEdit: '/PcPickcarOrder/order_can_edit', // 获取订单能否编辑
    // 3.75 保养营销优惠
    getMaintainMiniCode: '/MaintainPlan/get_maintain_page_qrcode', // 获取保养营销方案小程序码
    updateMainstanence: '/MaintainPlan/update_next_maintain_time', // 更新或者保存预计数据
    getMaintainUserCount: '/MaintainPlan/get_sstore_maintain_user_start', // 获取门店的重点营销车主数量
    getMaintainList: '/CustomerManage/get_maintain_record_list', // 获取预计下次保养列表信息
    deleteMaintainItem: '/CustomerManage/delete_maintain_record', // 删除预计下次保养列信息中的一项
    // 3.9
    unbindOwner: '/CustomerManage350/unbind_car', // 解绑车主
    // 4.0
    getMaintainItemList: '/MaintainPlan/get_maintain_item_list', // 保养项目列表
    getMaintainItemPlan: '/MaintainPlan/get_maintain_item_plan', // 根据保养编码获取计划商品和精友用量
    getCarSelectMileage: '/MaintainPlan/get_car_select_mileage', // 根据车辆预计保养和实际行驶里程计算查询里程

};



// WEBPACK FOOTER //
// ./src/api/apiMapping.js